export default __webpack_public_path__ + "static/media/08_Watch-the-sky-change_Share.964df42b.jpg";